module.exports = __webpack_public_path__ + "static/media/motorad-training.0e81d57a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/motorad-training.svg
// module id = 910
// module chunks = 0